export const en = {
  'shell.nav.corporate': 'Corporate',
  'enum.corporateQuoteStatus.DRAFT': 'Draft',
  'enum.corporateQuoteStatus.SENT': 'Sent',
  'enum.corporateQuoteStatus.ACCEPTED': 'Accepted',
  'enum.corporateQuoteStatus.DECLINED': 'Declined',
  'enum.corporateInvoiceStatus.ISSUED': 'Issued',
  'enum.corporateInvoiceStatus.PAID': 'Paid',
  'enum.corporateInvoiceStatus.VOID': 'Void',

  'reports.grouping.client': 'Corporate client',
  'reports.notCorporate': 'Not corporate',

  'gymSettings.sales.taxId': 'Identification code',
  'gymSettings.sales.taxIdHint': 'Printed on quotes and invoices to companies.',
  'gymSettings.sales.bankAccount': 'Bank account for invoices',
  'gymSettings.sales.bankAccountHint': 'The bank name and IBAN companies pay into.',

  'corporate.paidBy': 'Paid by {company}',

  'corporate.title': 'Corporate clients',
  'corporate.description': 'Companies that buy memberships for their staff: quotes, the employee list and invoices paid by bank transfer.',
  'corporate.tab.clients': 'Clients',
  'corporate.tab.quotes': 'Quotes',
  'corporate.tab.invoices': 'Invoices',
  'corporate.back': 'Corporate clients',
  'corporate.backToQuotes': 'Quotes',
  'corporate.backToInvoices': 'Invoices',
  'corporate.anyStatus': 'Any status',
  'corporate.archived': 'Archived',
  'corporate.expired': 'Expired',
  'corporate.overdue': 'Overdue',
  'corporate.total': 'Total',
  'corporate.subtotal': 'Subtotal',
  'corporate.discount': 'Discount',
  'corporate.notes': 'Notes',
  'corporate.createdOn': 'Created',
  'corporate.soldBy': 'Sold by',
  'corporate.soldByHint': 'Counts towards this person’s sales targets.',
  'corporate.soldByMe': '{name} (me)',
  'corporate.soldByNobody': 'Nobody',
  'corporate.language.en': 'English',
  'corporate.language.ka': 'Georgian',
  'corporate.pdf.en': 'PDF in English',
  'corporate.pdf.ka': 'PDF in Georgian',

  'corporate.clients.searchPlaceholder': 'Search clients',
  'corporate.clients.filter.ACTIVE': 'Active',
  'corporate.clients.filter.ARCHIVED': 'Archived',
  'corporate.clients.filter.ALL': 'All',
  'corporate.clients.empty': 'No corporate clients yet',
  'corporate.clients.emptyHint': 'Add a company to quote it a price for its staff’s memberships.',
  'corporate.clients.noMatch': 'No clients match',
  'corporate.clients.noMatchHint': 'Try another search or filter.',

  'corporate.client.label': 'Client',
  'corporate.client.name': 'Company name',
  'corporate.client.taxId': 'Identification code',
  'corporate.client.taxIdHint': 'Unique among your clients.',
  'corporate.client.taxIdLine': 'ID code {code}',
  'corporate.client.noTaxId': 'No identification code',
  'corporate.client.contact': 'Contact',
  'corporate.client.contactName': 'Contact person',
  'corporate.client.emailHint': 'Quotes are emailed here.',
  'corporate.client.address': 'Address',
  'corporate.client.billingTerms': 'Payment terms',
  'corporate.client.billingTermsHint': 'Days from issue to the due date of its invoices.',
  'corporate.client.billingTermsValue.one': '{count} day after issue',
  'corporate.client.billingTermsValue.other': '{count} days after issue',
  'corporate.client.discount': 'Discount',
  'corporate.client.discountHint': 'Whole percent, 0–99. Every new quote line starts with it.',
  'corporate.client.notes': 'Notes',
  'corporate.client.roster': 'Employees',
  'corporate.client.rosterCount.one': '{count} person',
  'corporate.client.rosterCount.other': '{count} people',
  'corporate.client.outstanding': 'Outstanding',
  'corporate.client.overdue': 'Overdue',
  'corporate.client.overdueAmount': '{amount} overdue',
  'corporate.client.details': 'Details',
  'corporate.client.new': 'New client',
  'corporate.client.newDescription': 'A company that buys memberships for its staff.',
  'corporate.client.edit': 'Edit client',
  'corporate.client.created': 'Client added',
  'corporate.client.updated': 'Client saved',
  'corporate.client.archive': 'Archive',
  'corporate.client.archiveTitle': 'Archive this client?',
  'corporate.client.archiveDescription': '{name} will leave the pickers. Its quotes, invoices and employee list stay.',
  'corporate.client.archivedToast': 'Client archived',
  'corporate.client.restore': 'Restore',
  'corporate.client.restored': 'Client restored',

  'corporate.roster.title': 'Employee list',
  'corporate.roster.description': 'The people the company buys memberships for.',
  'corporate.roster.add': 'Add member',
  'corporate.roster.addDescription': 'Add an existing member to the list of {company}.',
  'corporate.roster.addHint': 'A member can be on one company’s list at a time.',
  'corporate.roster.addSubmit': 'Add to list',
  'corporate.roster.added': '{name} added to the list',
  'corporate.roster.new': 'New member',
  'corporate.roster.newDescription': 'Create a member and add them to the list of {company}.',
  'corporate.roster.newSubmit': 'Create and add',
  'corporate.roster.empty': 'No one on the list yet',
  'corporate.roster.emptyHint': 'Add the people the company buys memberships for.',
  'corporate.roster.memberNumber': 'Number',
  'corporate.roster.membership': 'Membership',
  'corporate.roster.endsOn': 'ends {date}',
  'corporate.roster.paidByCompany': 'Paid by the company',
  'corporate.roster.noMembership': 'No membership',
  'corporate.roster.remove': 'Remove',
  'corporate.roster.removeNamed': 'Remove from the list: {name}',
  'corporate.roster.removeTitle': 'Remove from the list?',
  'corporate.roster.removeDescription': '{name} will no longer be on the list of {company}. Their memberships are not affected.',
  'corporate.roster.removed': 'Removed from the list',

  'corporate.quotes.searchPlaceholder': 'Search quotes',
  'corporate.quotes.empty': 'No quotes yet',
  'corporate.quotes.emptyHint': 'Make a quote to offer a company memberships for its staff.',
  'corporate.quotes.noMatch': 'No quotes match',
  'corporate.quotes.noMatchHint': 'Try another search or filter.',

  'corporate.quote.label': 'Quote',
  'corporate.quote.number': 'Number',
  'corporate.quote.new': 'New quote',
  'corporate.quote.newDescription': 'Offer a company memberships for its staff at a price.',
  'corporate.quote.edit': 'Edit quote',
  'corporate.quote.editTitle': 'Edit {number}',
  'corporate.quote.created': 'Quote created',
  'corporate.quote.updated': 'Quote saved',
  'corporate.quote.lines': 'Lines',
  'corporate.quote.plan': 'Membership plan',
  'corporate.quote.choosePlan': 'Choose a plan…',
  'corporate.quote.planRequired': 'Choose a plan',
  'corporate.quote.people': 'People',
  'corporate.quote.peopleInvalid': 'A whole number from 1 to 1000',
  'corporate.quote.price': 'Price per person ({currency})',
  'corporate.quote.priceInvalid': 'Enter an amount of 0 or more',
  'corporate.quote.unitPrice': 'Price per person',
  'corporate.quote.discount': 'Discount, %',
  'corporate.quote.discountInvalid': 'A whole percent from 0 to 99',
  'corporate.quote.lineAmounts': 'Subtotal {subtotal}, discount {discount}, total {total}',
  'corporate.quote.lineIncomplete': 'Fill in the plan and the number of people to see the amounts.',
  'corporate.quote.addLine': 'Add a line',
  'corporate.quote.removeLine': 'Remove',
  'corporate.quote.validUntil': 'Valid until',
  'corporate.quote.validUntilOn': 'Valid until {date}',
  'corporate.quote.validUntilRequired': 'Choose a date',
  'corporate.quote.language': 'Document language',
  'corporate.quote.languageHint': 'The language of the PDF and the email.',
  'corporate.quote.chooseClient': 'Choose a client…',
  'corporate.quote.clientRequired': 'Choose a client',
  'corporate.quote.sentEditNotice': 'This quote has been sent, so its lines stay as they are. You can move its date on and change its notes.',
  'corporate.quote.details': 'Details',
  'corporate.quote.sentOn': 'Sent',
  'corporate.quote.acceptedOn': 'Accepted',
  'corporate.quote.declinedOn': 'Declined',
  'corporate.quote.expiredNotice': 'This quote was valid until {date}. Move the date on (Edit) before sending or accepting it.',
  'corporate.quote.draftNotice': 'A draft. Nothing reaches the company until you send it.',
  'corporate.quote.send': 'Send',
  'corporate.quote.sendAgain': 'Send again',
  'corporate.quote.sendTitle': 'Send this quote?',
  'corporate.quote.sendAgainTitle': 'Send this quote again?',
  'corporate.quote.sendDescription': '{company} gets an email with the lines and the total of {number}; the PDF is not attached, so download it if they need one. If the company has no email address, the quote is only marked as sent and you pass the PDF on yourself.',
  'corporate.quote.sentByEmail': 'Quote emailed',
  'corporate.quote.sentNoEmail': 'Marked as sent. This client has no email, so download the PDF and pass it on.',
  'corporate.quote.accept': 'Accept',
  'corporate.quote.decline': 'Decline',
  'corporate.quote.declineTitle': 'Decline this quote?',
  'corporate.quote.declineDescription': '{number} will be marked as declined. This cannot be undone.',
  'corporate.quote.declined': 'Quote declined',

  'corporate.accept.title': 'Accept quote',
  'corporate.accept.description': 'Choose who on the list of {company} gets each membership.',
  'corporate.accept.lineTitle': '{plan} × {quantity}',
  'corporate.accept.chosen': '{chosen} of {quantity} chosen',
  'corporate.accept.rosterShort': 'The list has {roster} people but the quote needs {needed}.',
  'corporate.accept.addPeople': 'Add people on the client page',
  'corporate.accept.rosterEmpty': 'The list is empty.',
  'corporate.accept.submit': 'Accept and issue invoice',
  'corporate.accept.effect': 'Accepting issues an invoice to the company. Each person’s membership waits as pending until the invoice is paid, then starts on the day chosen above, or on the payment day.',
  'corporate.accept.done': 'Quote accepted. Invoice {number} issued',
  'corporate.accept.startsOn': 'Memberships start on',
  'corporate.accept.startsOnHint': 'Empty: on the day the payment is recorded',
  'corporate.accept.emailInvoice': 'Email the invoice to {email}',
  'corporate.accept.emailInvoiceNoAddress': 'Email the invoice',
  'corporate.accept.noEmail': 'The client has no email address; download the PDF and send it yourself.',

  'corporate.invoices.searchPlaceholder': 'Search invoices',
  'corporate.invoices.outstanding': 'Outstanding',
  'corporate.invoices.outstandingHint': 'Issued, not yet paid',
  'corporate.invoices.overdue': 'Overdue',
  'corporate.invoices.overdueCount.one': '{count} invoice past its due date',
  'corporate.invoices.overdueCount.other': '{count} invoices past their due date',
  'corporate.invoices.overdueOnly': 'Overdue only',
  'corporate.invoices.empty': 'No invoices yet',
  'corporate.invoices.emptyHint': 'An invoice is issued when a company accepts a quote.',
  'corporate.invoices.noMatch': 'No invoices match',
  'corporate.invoices.noMatchHint': 'Try another search or filter.',

  'corporate.invoice.label': 'Invoice',
  'corporate.invoice.number': 'Number',
  'corporate.invoice.issued': 'Issued',
  'corporate.invoice.due': 'Due',
  'corporate.invoice.dueOn': 'Due {date}',
  'corporate.invoice.details': 'Details',
  'corporate.invoice.lines': 'Lines and people',
  'corporate.invoice.refunded': 'Refunded',
  'corporate.invoice.paidOn': 'Paid on',
  'corporate.invoice.reference': 'Bank reference',
  'corporate.invoice.referenceHint': 'The bank’s reference for the transfer. Optional.',
  'corporate.invoice.recordedBy': 'Recorded by',
  'corporate.invoice.markPaid': 'Mark paid',
  'corporate.invoice.payDescription': 'Record the bank transfer of {amount} for {number}.',
  'corporate.invoice.receivedOn': 'Received on',
  'corporate.invoice.receivedOnHint': 'The day the transfer reached the gym’s account. Not in the future.',
  'corporate.invoice.payEffect': 'Marking it paid confirms each person’s payment and starts their pending memberships.',
  'corporate.invoice.paidToast': 'Invoice marked paid',
  'corporate.invoice.void': 'Void',
  'corporate.invoice.voidTitle': 'Void this invoice?',
  'corporate.invoice.voidDescription': '{number} will be voided and the memberships waiting for it are cancelled. This cannot be undone.',
  'corporate.invoice.voided': 'Invoice voided',
  'corporate.invoice.voidedNotice': 'Voided by {name} on {date}',
  'corporate.invoice.voidReason': 'Reason: {reason}',
  'corporate.invoice.issuedNotice': 'Waiting for the company’s bank transfer. Mark it paid when the money arrives.',
  'corporate.invoice.paidNotice': 'Paid. Refunds go through each person’s payment, not through the invoice.',
  'corporate.invoice.memberRefunded': '{amount} refunded',
  'corporate.invoice.startsOn': 'Memberships start on',
  'corporate.invoice.emailed': 'Invoice email',
  'corporate.invoice.emailedTo': 'Sent to {address} on {date}',

  'admin.apiError.CORPORATE_CLIENT_EXISTS': 'Another client of the gym already has this identification code.',
  'admin.apiError.CLIENT_ARCHIVED': 'This client is archived. Restore it before selling to it.',
  'admin.apiError.MEMBER_ON_OTHER_ROSTER': 'This member is already on another company’s list. Remove them from it first.',
  'admin.apiError.LINE_TOTAL_TOO_LOW': 'Every person on a line must pay something. A free membership is given at the front desk, with a reason.',
  'admin.apiError.QUOTE_TOO_LARGE': 'This quote is too large. Split it into several quotes.',
  'admin.apiError.VALID_UNTIL_PAST': 'A quote must be valid until today or later.',
  'admin.apiError.QUOTE_SENT': 'A sent quote keeps its lines. Only its date and notes can change.',
  'admin.apiError.QUOTE_DECIDED': 'This quote is already accepted or declined.',
  'admin.apiError.QUOTE_NOT_SENT': 'Send the quote before marking it accepted.',
  'admin.apiError.QUOTE_EXPIRED': 'This quote is past its date. Move the date on first.',
  'admin.apiError.ROSTER_COUNT_MISMATCH': 'A line is for {quantity} people; {chosen} were chosen.',
  'admin.apiError.MEMBER_NOT_ON_ROSTER': 'Everyone chosen must be on the company’s list.',
  'admin.apiError.MEMBER_TWICE': 'A person is chosen twice on one line.',
  'admin.apiError.INVOICE_PAID': 'This invoice is already paid. Refund its payments one by one instead.',
  'admin.apiError.INVOICE_VOID': 'This invoice was voided.',
  'admin.apiError.PAID_IN_FUTURE': 'A transfer cannot be dated after today.',
  'admin.apiError.STARTS_IN_PAST': 'The memberships cannot start before today.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.corporate': 'კორპორატიული',
  'enum.corporateQuoteStatus.DRAFT': 'მონახაზი',
  'enum.corporateQuoteStatus.SENT': 'გაგზავნილი',
  'enum.corporateQuoteStatus.ACCEPTED': 'დადასტურებული',
  'enum.corporateQuoteStatus.DECLINED': 'უარყოფილი',
  'enum.corporateInvoiceStatus.ISSUED': 'გამოწერილი',
  'enum.corporateInvoiceStatus.PAID': 'გადახდილი',
  'enum.corporateInvoiceStatus.VOID': 'გაუქმებული',

  'reports.grouping.client': 'კორპორატიული კლიენტი',
  'reports.notCorporate': 'არაკორპორატიული',

  'gymSettings.sales.taxId': 'საიდენტიფიკაციო კოდი',
  'gymSettings.sales.taxIdHint': 'იბეჭდება კომპანიებისთვის გაგზავნილ შეთავაზებებსა და ინვოისებზე.',
  'gymSettings.sales.bankAccount': 'საბანკო ანგარიში ინვოისებისთვის',
  'gymSettings.sales.bankAccountHint': 'ბანკის დასახელება და IBAN, რომელზეც კომპანიები გადაიხდიან.',

  'corporate.paidBy': 'იხდის: {company}',

  'corporate.title': 'კორპორატიული კლიენტები',
  'corporate.description': 'კომპანიები, რომლებიც თანამშრომლებისთვის აბონემენტებს ყიდულობენ: შეთავაზებები, თანამშრომლების სია და საბანკო გადარიცხვით გადასახდელი ინვოისები.',
  'corporate.tab.clients': 'კლიენტები',
  'corporate.tab.quotes': 'შეთავაზებები',
  'corporate.tab.invoices': 'ინვოისები',
  'corporate.back': 'კორპორატიული კლიენტები',
  'corporate.backToQuotes': 'შეთავაზებები',
  'corporate.backToInvoices': 'ინვოისები',
  'corporate.anyStatus': 'ნებისმიერი სტატუსი',
  'corporate.archived': 'დაარქივებული',
  'corporate.expired': 'ვადაგასული',
  'corporate.overdue': 'ვადაგადაცილებული',
  'corporate.total': 'ჯამი',
  'corporate.subtotal': 'ქვეჯამი',
  'corporate.discount': 'ფასდაკლება',
  'corporate.notes': 'შენიშვნები',
  'corporate.createdOn': 'შექმნის თარიღი',
  'corporate.soldBy': 'გამყიდველი',
  'corporate.soldByHint': 'ითვლება ამ ადამიანის გაყიდვების მიზნებში.',
  'corporate.soldByMe': '{name} (მე)',
  'corporate.soldByNobody': 'არავინ',
  'corporate.language.en': 'ინგლისური',
  'corporate.language.ka': 'ქართული',
  'corporate.pdf.en': 'PDF ინგლისურად',
  'corporate.pdf.ka': 'PDF ქართულად',

  'corporate.clients.searchPlaceholder': 'კლიენტების ძებნა',
  'corporate.clients.filter.ACTIVE': 'აქტიური',
  'corporate.clients.filter.ARCHIVED': 'დაარქივებული',
  'corporate.clients.filter.ALL': 'ყველა',
  'corporate.clients.empty': 'კორპორატიული კლიენტები ჯერ არ არის',
  'corporate.clients.emptyHint': 'დაამატეთ კომპანია, რომ თანამშრომლების აბონემენტებზე შეთავაზება გაუგზავნოთ.',
  'corporate.clients.noMatch': 'კლიენტი ვერ მოიძებნა',
  'corporate.clients.noMatchHint': 'სცადეთ სხვა ძებნა ან ფილტრი.',

  'corporate.client.label': 'კლიენტი',
  'corporate.client.name': 'კომპანიის დასახელება',
  'corporate.client.taxId': 'საიდენტიფიკაციო კოდი',
  'corporate.client.taxIdHint': 'უნიკალური უნდა იყოს თქვენს კლიენტებს შორის.',
  'corporate.client.taxIdLine': 'საიდენტიფიკაციო კოდი: {code}',
  'corporate.client.noTaxId': 'საიდენტიფიკაციო კოდი მითითებული არ არის',
  'corporate.client.contact': 'კონტაქტი',
  'corporate.client.contactName': 'საკონტაქტო პირი',
  'corporate.client.emailHint': 'შეთავაზებები გაიგზავნება ამ მისამართზე.',
  'corporate.client.address': 'მისამართი',
  'corporate.client.billingTerms': 'გადახდის ვადა',
  'corporate.client.billingTermsHint': 'დღეების რაოდენობა ინვოისის გამოწერიდან გადახდის ვადამდე.',
  'corporate.client.billingTermsValue.one': '{count} დღე გამოწერიდან',
  'corporate.client.billingTermsValue.other': '{count} დღე გამოწერიდან',
  'corporate.client.discount': 'ფასდაკლება',
  'corporate.client.discountHint': 'მთელი პროცენტი, 0–99. შეთავაზების ყოველი ახალი პოზიცია ამ ფასდაკლებით იწყება.',
  'corporate.client.notes': 'შენიშვნები',
  'corporate.client.roster': 'თანამშრომლები',
  'corporate.client.rosterCount.one': '{count} თანამშრომელი',
  'corporate.client.rosterCount.other': '{count} თანამშრომელი',
  'corporate.client.outstanding': 'გადასახდელი',
  'corporate.client.overdue': 'ვადაგადაცილებული',
  'corporate.client.overdueAmount': 'ვადაგადაცილებულია {amount}',
  'corporate.client.details': 'დეტალები',
  'corporate.client.new': 'ახალი კლიენტი',
  'corporate.client.newDescription': 'კომპანია, რომელიც თანამშრომლებისთვის აბონემენტებს ყიდულობს.',
  'corporate.client.edit': 'კლიენტის რედაქტირება',
  'corporate.client.created': 'კლიენტი დაემატა',
  'corporate.client.updated': 'კლიენტი შენახულია',
  'corporate.client.archive': 'დაარქივება',
  'corporate.client.archiveTitle': 'დაარქივდეს ეს კლიენტი?',
  'corporate.client.archiveDescription': '„{name}“ აღარ გამოჩნდება არჩევის სიებში. მისი შეთავაზებები, ინვოისები და თანამშრომლების სია შენარჩუნდება.',
  'corporate.client.archivedToast': 'კლიენტი დაარქივდა',
  'corporate.client.restore': 'აღდგენა',
  'corporate.client.restored': 'კლიენტი აღდგა',

  'corporate.roster.title': 'თანამშრომლების სია',
  'corporate.roster.description': 'ადამიანები, რომლებისთვისაც კომპანია აბონემენტებს ყიდულობს.',
  'corporate.roster.add': 'წევრის დამატება',
  'corporate.roster.addDescription': 'დაამატეთ არსებული წევრი კომპანია „{company}“-ის სიაში.',
  'corporate.roster.addHint': 'წევრი ერთდროულად მხოლოდ ერთი კომპანიის სიაში შეიძლება იყოს.',
  'corporate.roster.addSubmit': 'სიაში დამატება',
  'corporate.roster.added': '{name} დაემატა სიას',
  'corporate.roster.new': 'ახალი წევრი',
  'corporate.roster.newDescription': 'შექმენით წევრი და დაამატეთ კომპანია „{company}“-ის სიაში.',
  'corporate.roster.newSubmit': 'შექმნა და დამატება',
  'corporate.roster.empty': 'სია ჯერ ცარიელია',
  'corporate.roster.emptyHint': 'დაამატეთ ადამიანები, რომლებისთვისაც კომპანია აბონემენტებს ყიდულობს.',
  'corporate.roster.memberNumber': 'ნომერი',
  'corporate.roster.membership': 'აბონემენტი',
  'corporate.roster.endsOn': 'მთავრდება {date}',
  'corporate.roster.paidByCompany': 'იხდის კომპანია',
  'corporate.roster.noMembership': 'აბონემენტი არ აქვს',
  'corporate.roster.remove': 'ამოღება',
  'corporate.roster.removeNamed': 'სიიდან ამოღება: {name}',
  'corporate.roster.removeTitle': 'ამოიღოთ სიიდან?',
  'corporate.roster.removeDescription': '{name} აღარ იქნება კომპანია „{company}“-ის სიაში. მისი აბონემენტები არ შეიცვლება.',
  'corporate.roster.removed': 'სიიდან ამოღებულია',

  'corporate.quotes.searchPlaceholder': 'შეთავაზებების ძებნა',
  'corporate.quotes.empty': 'შეთავაზებები ჯერ არ არის',
  'corporate.quotes.emptyHint': 'შექმენით შეთავაზება, რომ კომპანიას თანამშრომლებისთვის აბონემენტები შესთავაზოთ.',
  'corporate.quotes.noMatch': 'შეთავაზება ვერ მოიძებნა',
  'corporate.quotes.noMatchHint': 'სცადეთ სხვა ძებნა ან ფილტრი.',

  'corporate.quote.label': 'შეთავაზება',
  'corporate.quote.number': 'ნომერი',
  'corporate.quote.new': 'ახალი შეთავაზება',
  'corporate.quote.newDescription': 'შესთავაზეთ კომპანიას თანამშრომლების აბონემენტები გარკვეულ ფასად.',
  'corporate.quote.edit': 'შეთავაზების რედაქტირება',
  'corporate.quote.editTitle': 'რედაქტირება: {number}',
  'corporate.quote.created': 'შეთავაზება შეიქმნა',
  'corporate.quote.updated': 'შეთავაზება შენახულია',
  'corporate.quote.lines': 'პოზიციები',
  'corporate.quote.plan': 'აბონემენტის პაკეტი',
  'corporate.quote.choosePlan': 'აირჩიეთ პაკეტი…',
  'corporate.quote.planRequired': 'აირჩიეთ პაკეტი',
  'corporate.quote.people': 'ადამიანები',
  'corporate.quote.peopleInvalid': 'მთელი რიცხვი 1-დან 1000-მდე',
  'corporate.quote.price': 'ფასი ერთ ადამიანზე ({currency})',
  'corporate.quote.priceInvalid': 'შეიყვანეთ 0 ან მეტი თანხა',
  'corporate.quote.unitPrice': 'ფასი ერთ ადამიანზე',
  'corporate.quote.discount': 'ფასდაკლება, %',
  'corporate.quote.discountInvalid': 'მთელი პროცენტი 0-დან 99-მდე',
  'corporate.quote.lineAmounts': 'ქვეჯამი {subtotal}, ფასდაკლება {discount}, ჯამი {total}',
  'corporate.quote.lineIncomplete': 'თანხების სანახავად შეავსეთ პაკეტი და ადამიანების რაოდენობა.',
  'corporate.quote.addLine': 'პოზიციის დამატება',
  'corporate.quote.removeLine': 'წაშლა',
  'corporate.quote.validUntil': 'მოქმედების ვადა',
  'corporate.quote.validUntilOn': 'მოქმედებს {date}-მდე',
  'corporate.quote.validUntilRequired': 'აირჩიეთ თარიღი',
  'corporate.quote.language': 'დოკუმენტის ენა',
  'corporate.quote.languageHint': 'PDF-ისა და ელფოსტის ენა.',
  'corporate.quote.chooseClient': 'აირჩიეთ კლიენტი…',
  'corporate.quote.clientRequired': 'აირჩიეთ კლიენტი',
  'corporate.quote.sentEditNotice': 'ეს შეთავაზება გაგზავნილია, ამიტომ მისი პოზიციები აღარ იცვლება. შეგიძლიათ თარიღის გადაწევა და შენიშვნის შეცვლა.',
  'corporate.quote.details': 'დეტალები',
  'corporate.quote.sentOn': 'გაგზავნის თარიღი',
  'corporate.quote.acceptedOn': 'დადასტურების თარიღი',
  'corporate.quote.declinedOn': 'უარყოფის თარიღი',
  'corporate.quote.expiredNotice': 'ამ შეთავაზების ვადა {date}-მდე იყო. გაგზავნამდე ან დადასტურებამდე გადაწიეთ თარიღი („რედაქტირება“).',
  'corporate.quote.draftNotice': 'ეს მონახაზია. კომპანიამდე არაფერი მიდის, სანამ არ გააგზავნით.',
  'corporate.quote.send': 'გაგზავნა',
  'corporate.quote.sendAgain': 'ხელახლა გაგზავნა',
  'corporate.quote.sendTitle': 'გაიგზავნოს ეს შეთავაზება?',
  'corporate.quote.sendAgainTitle': 'ხელახლა გაიგზავნოს ეს შეთავაზება?',
  'corporate.quote.sendDescription': 'კომპანია „{company}“ მიიღებს ელფოსტას {number}-ის პოზიციებითა და ჯამით; PDF არ ერთვის, ამიტომ საჭიროების შემთხვევაში ჩამოტვირთეთ. თუ კომპანიას ელფოსტა არ აქვს, შეთავაზება მხოლოდ გაგზავნილად მოინიშნება და PDF-ს თავად გადასცემთ.',
  'corporate.quote.sentByEmail': 'შეთავაზება გაიგზავნა ელფოსტით',
  'corporate.quote.sentNoEmail': 'გაგზავნილად მოინიშნა. კლიენტს ელფოსტა არ აქვს, ამიტომ ჩამოტვირთეთ PDF და თავად გადაეცით.',
  'corporate.quote.accept': 'დადასტურება',
  'corporate.quote.decline': 'უარყოფა',
  'corporate.quote.declineTitle': 'უარყოფილ იქნეს ეს შეთავაზება?',
  'corporate.quote.declineDescription': '{number} უარყოფილად მოინიშნება. ამის გაუქმება შეუძლებელია.',
  'corporate.quote.declined': 'შეთავაზება უარყოფილია',

  'corporate.accept.title': 'შეთავაზების დადასტურება',
  'corporate.accept.description': 'აირჩიეთ, კომპანია „{company}“-ის სიიდან ვინ მიიღებს თითოეულ აბონემენტს.',
  'corporate.accept.lineTitle': '{plan} × {quantity}',
  'corporate.accept.chosen': 'არჩეულია {chosen} / {quantity}',
  'corporate.accept.rosterShort': 'სიაში {roster} ადამიანია, შეთავაზებას კი {needed} სჭირდება.',
  'corporate.accept.addPeople': 'დაამატეთ ადამიანები კლიენტის გვერდზე',
  'corporate.accept.rosterEmpty': 'სია ცარიელია.',
  'corporate.accept.submit': 'დადასტურება და ინვოისის გამოწერა',
  'corporate.accept.effect': 'დადასტურებისას კომპანიას ინვოისი გამოეწერება. თითოეული ადამიანის აბონემენტი ინვოისის გადახდამდე მოლოდინში იქნება, შემდეგ კი დაიწყება ზემოთ არჩეულ დღეს ან გადახდის დღეს.',
  'corporate.accept.done': 'შეთავაზება დადასტურდა. ინვოისი {number} გამოიწერა',
  'corporate.accept.startsOn': 'აბონემენტები იწყება',
  'corporate.accept.startsOnHint': 'თუ ცარიელია, გადახდის აღრიცხვის დღეს',
  'corporate.accept.emailInvoice': 'ინვოისის გაგზავნა ელფოსტაზე {email}',
  'corporate.accept.emailInvoiceNoAddress': 'ინვოისის გაგზავნა ელფოსტით',
  'corporate.accept.noEmail': 'კლიენტს ელფოსტის მისამართი არ აქვს. ჩამოტვირთეთ PDF და თავად გაუგზავნეთ.',

  'corporate.invoices.searchPlaceholder': 'ინვოისების ძებნა',
  'corporate.invoices.outstanding': 'გადასახდელი',
  'corporate.invoices.outstandingHint': 'გამოწერილია, ჯერ არ არის გადახდილი',
  'corporate.invoices.overdue': 'ვადაგადაცილებული',
  'corporate.invoices.overdueCount.one': '{count} ინვოისი ვადაგადაცილებულია',
  'corporate.invoices.overdueCount.other': '{count} ინვოისი ვადაგადაცილებულია',
  'corporate.invoices.overdueOnly': 'მხოლოდ ვადაგადაცილებული',
  'corporate.invoices.empty': 'ინვოისები ჯერ არ არის',
  'corporate.invoices.emptyHint': 'ინვოისი გამოიწერება, როცა კომპანია შეთავაზებას ადასტურებს.',
  'corporate.invoices.noMatch': 'ინვოისი ვერ მოიძებნა',
  'corporate.invoices.noMatchHint': 'სცადეთ სხვა ძებნა ან ფილტრი.',

  'corporate.invoice.label': 'ინვოისი',
  'corporate.invoice.number': 'ნომერი',
  'corporate.invoice.issued': 'გამოწერის თარიღი',
  'corporate.invoice.due': 'გადახდის ვადა',
  'corporate.invoice.dueOn': 'გადახდის ვადა: {date}',
  'corporate.invoice.details': 'დეტალები',
  'corporate.invoice.lines': 'პოზიციები და ადამიანები',
  'corporate.invoice.refunded': 'დაბრუნებული თანხა',
  'corporate.invoice.paidOn': 'გადახდის თარიღი',
  'corporate.invoice.reference': 'გადარიცხვის მინიშნება',
  'corporate.invoice.referenceHint': 'ბანკის მინიშნება გადარიცხვაზე. არასავალდებულო.',
  'corporate.invoice.recordedBy': 'აღრიცხა',
  'corporate.invoice.markPaid': 'გადახდილად მონიშვნა',
  'corporate.invoice.payDescription': 'აღრიცხეთ {number}-ის საბანკო გადარიცხვა: {amount}.',
  'corporate.invoice.receivedOn': 'ჩარიცხვის თარიღი',
  'corporate.invoice.receivedOnHint': 'დღე, როცა გადარიცხვა დარბაზის ანგარიშზე აისახა. მომავალი თარიღი არ შეიძლება.',
  'corporate.invoice.payEffect': 'გადახდილად მონიშვნისას თითოეული ადამიანის გადახდა დადასტურდება და მოლოდინში მყოფი აბონემენტები დაიწყება.',
  'corporate.invoice.paidToast': 'ინვოისი გადახდილად მოინიშნა',
  'corporate.invoice.void': 'გაუქმება',
  'corporate.invoice.voidTitle': 'გაუქმდეს ეს ინვოისი?',
  'corporate.invoice.voidDescription': '{number} გაუქმდება და მასზე მოლოდინში მყოფი აბონემენტებიც გაუქმდება. ამის გაუქმება შეუძლებელია.',
  'corporate.invoice.voided': 'ინვოისი გაუქმდა',
  'corporate.invoice.voidedNotice': 'გააუქმა {name}, {date}',
  'corporate.invoice.voidReason': 'მიზეზი: {reason}',
  'corporate.invoice.issuedNotice': 'კომპანიის საბანკო გადარიცხვას ელოდება. თანხის მიღებისას მონიშნეთ გადახდილად.',
  'corporate.invoice.paidNotice': 'გადახდილია. თანხა ბრუნდება თითოეული ადამიანის გადახდის მეშვეობით და არა ინვოისიდან.',
  'corporate.invoice.memberRefunded': 'დაბრუნებულია {amount}',
  'corporate.invoice.startsOn': 'აბონემენტები იწყება',
  'corporate.invoice.emailed': 'ინვოისის ელფოსტა',
  'corporate.invoice.emailedTo': 'გაიგზავნა მისამართზე {address}, {date}',

  'admin.apiError.CORPORATE_CLIENT_EXISTS': 'სხვა კლიენტს დარბაზში უკვე აქვს ეს საიდენტიფიკაციო კოდი.',
  'admin.apiError.CLIENT_ARCHIVED': 'ეს კლიენტი დაარქივებულია. გაყიდვამდე აღადგინეთ.',
  'admin.apiError.MEMBER_ON_OTHER_ROSTER': 'ეს წევრი უკვე სხვა კომპანიის თანამშრომლების სიაშია. ჯერ ამოიღეთ იქიდან.',
  'admin.apiError.LINE_TOTAL_TOO_LOW': 'თითოეულმა ადამიანმა რაღაც თანხა უნდა გადაიხადოს. უფასო აბონემენტი მიმღებზე გაიცემა, მიზეზის მითითებით.',
  'admin.apiError.QUOTE_TOO_LARGE': 'ეს შეთავაზება ზედმეტად დიდია. გაყავით რამდენიმე შეთავაზებად.',
  'admin.apiError.VALID_UNTIL_PAST': 'შეთავაზება უნდა მოქმედებდეს დღევანდელი თარიღით ან უფრო გვიან.',
  'admin.apiError.QUOTE_SENT': 'გაგზავნილი შეთავაზების პოზიციები აღარ იცვლება. შეიძლება შეიცვალოს მხოლოდ თარიღი და შენიშვნა.',
  'admin.apiError.QUOTE_DECIDED': 'ეს შეთავაზება უკვე დადასტურებულია ან უარყოფილია.',
  'admin.apiError.QUOTE_NOT_SENT': 'დადასტურებამდე გააგზავნეთ შეთავაზება.',
  'admin.apiError.QUOTE_EXPIRED': 'ამ შეთავაზების ვადა გავიდა. ჯერ გადაწიეთ თარიღი.',
  'admin.apiError.ROSTER_COUNT_MISMATCH': 'პოზიცია {quantity} ადამიანზეა გათვლილი, არჩეულია {chosen}.',
  'admin.apiError.MEMBER_NOT_ON_ROSTER': 'არჩეული ადამიანები კომპანიის თანამშრომლების სიაში უნდა იყვნენ.',
  'admin.apiError.MEMBER_TWICE': 'ერთ პოზიციაზე ერთი ადამიანი ორჯერაა არჩეული.',
  'admin.apiError.INVOICE_PAID': 'ეს ინვოისი უკვე გადახდილია. გადახდები ცალ-ცალკე დააბრუნეთ.',
  'admin.apiError.INVOICE_VOID': 'ეს ინვოისი გაუქმებულია.',
  'admin.apiError.PAID_IN_FUTURE': 'გადარიცხვის თარიღი დღევანდელზე გვიან ვერ იქნება.',
  'admin.apiError.STARTS_IN_PAST': 'აბონემენტები დღევანდელზე ადრე ვერ დაიწყება.',
};
